import _ from "underscore";
import TemplateView from "../../../js/TemplateView";

function APReportsPage($containerEl)
{
    TemplateView.call(this, $containerEl);
}

APReportsPage.prototype = _.create(TemplateView.prototype, {
    html: "<div id='apReportsContent'>" +
          "  <div id='apReportsHeaderPlaceholder'></div>" +
          "  <div id='apLeaveTimeReportPlaceholder'></div>" +
          "  <div id='apPastLeavesCalendarPlaceholder'></div>" +
          "  <div id='apBalanceHistoryPlaceholder'></div>" +
          "</div>"
});

export default APReportsPage;



// WEBPACK FOOTER //
// ./web/actiplans/js/reports/APReportsPage.js